import { SET_DRUG_LIST } from '../constants/Drug';

const initState = {
  drugList: []
};

const drug = (state = initState, action) => {
  switch (action.type) {
    case SET_DRUG_LIST:
      return {
        ...state,
        drugList: action.drugList
      };
    default:
      return state;
  }
};

export default drug;
